export const html: string = `<div data-book-id="{{ bookId }}"
	data-ui-name="book"
	role="group"
	aria-roledescription="{{ lang.BOOK_ROLE_DESCRIPTION }}"
	aria-labelledby="book-{{ bookId }}-title"
	data-ui-book-id="{{ bookId }}"
	data-myon-attr-class="book -teacher {{ lengthClass }} {{ focused? | '-focused' }} {{ card? | '-card' }} {{ row? | '-row' }} {{ checkbox? | '-checkbox' }}">
	<div class="book_cell -checkbox" data-myon-if="{{ checkbox }}">
		<input data-myon-name="checkbox" aria-label="{{ lang.ACTION_SELECT }}" data-myon-on-change="handleCheckChange" class="checkbox" name="book[]" type="checkbox" value="{{ bookId }}" />
	</div>
	<div class="book_cell -cover" data-myon-name="coverCell">
		<div class="book_cover" data-myon-name="cover" data-myon-click="handleInfoClicked">
			<div class="book_coverImgRatioFix" data-myon-name="imgRatioFix">
				<div class="book_page -backCover"></div>
				<div class="book_page -n4"></div>
				<div class="book_page -n3"></div>
				<div class="book_page -n2"></div>
				<div class="book_page -n1"></div>
				<img draggable="false" data-myon-name="img" class="book_coverImg" alt="{{ title | getCoverAlt }}" />
			</div>
		</div>
	</div>
	<div class="book_cell -title">
		<button type="button" class="book_title link" data-myon-click="handleInfoClicked">
			<div class="book_titleWrap" lang="{{ langString }}" id="book-{{ bookId }}-title">
				{{ title }}
			</div>
		</button>
	</div>
	<div class="book_cell -description">
		<div class="book_description" lang="{{ langString }}">{{ description }}</div>
	</div>
	<div class="book_cell -cardMetrics">
		<dl class="book_data -card">
			<div class="book_dataGroup -card" data-myon-template="cardMetrics">
				<dt class="book_dataLabel">{{ metric.label }}</dt>
				<dd class="book_dataValue" data-ui-name="{{ metric.label }}" data-ui-book-id="{{ bookId }}">{{ metric | formatMetricValue }}</dd>
			</div>
		</dl>
	</div>
	<div class="book_cell -listMetrics">
		<dl class="book_data -list">
			<div class="book_dataGroup -list" data-myon-template="listMetrics">
				<dt class="book_dataLabel">{{ metric.label }}</dt>
				<dd class="book_dataValue" data-ui-name="{{ metric.label }}" data-ui-book-id="{{ bookId }}">{{ metric | formatMetricValue @noescape }}</dd>
			</div>
		</dl>
	</div>
	<div class="book_cell -listLabels">
		<dl class="book_data -labels">
			<div class="book_dataGroup -labels" data-myon-template="listLabels">
				<dt class="book_dataLabel">{{ metric.label }}</dt>
				<dd class="book_dataValue" data-ui-name="{{ metric.label }}" data-ui-book-id="{{ bookId }}">{{ metric | formatMetricValue @noescape }}</dd>
			</div>
		</dl>
	</div>
	<div class="book_cell -controls">
		<div class="book_controls flex -row" data-myon-name="controls">
			<button type="button"
				class="flex_item button -primary book_control"
				aria-label="{{ lang.ACTION_OPEN_LONG }}"
				data-ui-name="bookRead"
				data-ui-book-id="{{ bookId }}"
				data-myon-click="handleReadButtonClicked">
				{{ lang.ACTION_OPEN }}
			</button>
			<button type="button"
				class="flex_item button -secondary book_control -assign"
				data-myon-if="{{ showAssignButton }}"
				data-myon-name="assignButton"
				data-myon-on-click="handleAssignButtonClicked"
				data-ui-name="bookAssign"
				data-ui-book-id="{{ bookId }}">
				{{ lang.ACTION_ASSIGN }}
			</button>
		</div>
	</div>
	<div class="book_cell -extra" data-myon-name="extraActions">
		<button type="button" class="link book_extraAction" data-myon-on-click="handleMyListButtonClicked" data-myon-name="myListButton">
			<i data-myon-attr-class="link_icon mycon {{ isOnMyList? | '-mylist-remove-small' }} {{ !isOnMyList? | '-mylist-add-small' }}"></i>
			<span data-myon-if="{{ !isOnMyList }}">
				{{ lang.ACTION_ADD_SHORT }}
			</span>
			<span data-myon-if="{{ isOnMyList }}">
				{{ lang.STATUS_FAVORITED }}
			</span>
		</button>
	</div>
</div>`;
